import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'ngx-executing-request',
  templateUrl: './executing-request.component.html',
  styleUrls: ['./executing-request.component.scss']
})
export class ExecutingRequestComponent implements OnInit {

  @Input() message: string;
  @Input() users: any;
  @Input() connector: any;
  @Input() showCloseButton: boolean;

  /** 
   * Reference to the parent dialog (if this popup was opened from another popup). 
   * Used to close the parent dialog when needed. 
  */
  @Input() parentDialogRef: NbDialogRef<any>
  
  /** a variable for alerted users */
  alerted : any;

  alertUserId : string = environment.alertUserId;
  public constructor(protected ref: NbDialogRef<ExecutingRequestComponent>){} 


  ngOnInit(){
  }

  close() {
    this.ref.close();

    // close the parent pop up if exists
    const parentDialogRef = this.parentDialogRef;
    if (parentDialogRef) {
      parentDialogRef.close();
    }
  }
}
